/* WBF Phone Finder. Keep native Dawn variant selector authoritative. */
(() => {
'use strict';
if(window.WBFPhoneFinder)return;
window.WBFPhoneFinder=true;
const finder='[data-wbf-phone-finder]';
function native(root){
 const section=root.closest('product-info') || root.closest('.shopify-section') || document;
 const all=[...section.querySelectorAll('variant-selects select')];
 return all.find(s=>/options\[(size|maat|telefoonmodel)\]/i.test(s.name))
  ||all.find(s=>[...s.options].some(o=>/iphone|samsung|pixel/i.test(o.textContent)));
}
function selected(root){
 const s=native(root),p=root.querySelector('[data-wbf-model-selected]');
 if(s&&p)p.textContent='Geselecteerd: '+s.selectedOptions[0].textContent.trim();
}
function list(root){
 const input=root.querySelector('[data-wbf-model-input]');
 const box=root.querySelector('[data-wbf-model-results]');
 const s=native(root);if(!input||!box||!s)return;
 const value=input.value.trim().toLowerCase();
 const choices=[...s.options].filter(o=>o.value&&o.textContent.toLowerCase().includes(value));
 box.replaceChildren();
 for(const opt of choices.slice(0,12)){
   const button=document.createElement('button');
   button.type='button';
   button.className='wbf-model-finder__option';
   button.textContent=opt.textContent.trim();
   button.dataset.wbfModelValue=opt.value;
   button.disabled=opt.disabled;
   button.setAttribute('aria-current',String(opt.value===s.value));
   box.appendChild(button);
 }
 if(!choices.length){const p=document.createElement('p');p.className='wbf-model-finder__empty';p.textContent='Geen modellen gevonden. Probeer een andere zoekterm.';box.appendChild(p)}
 if(choices.length>12){const p=document.createElement('p');p.className='wbf-model-finder__empty';p.textContent='Typ verder om de resultaten te verfijnen.';box.appendChild(p)}
 box.hidden=false;input.setAttribute('aria-expanded','true');
}
function hide(root){
 const box=root.querySelector('[data-wbf-model-results]');
 const input=root.querySelector('[data-wbf-model-input]');
 if(box)box.hidden=true;
 if(input)input.setAttribute('aria-expanded','false');
}
function mount(){
 for(const root of document.querySelectorAll(finder)){
  const s=native(root);if(!s)continue;
  s.closest('.product-form__input--dropdown')?.classList.add('wbf-model-native--hidden');
  selected(root);
 }
}
document.addEventListener('focusin',e=>{const input=e.target.closest?.('[data-wbf-model-input]');if(input)list(input.closest(finder))});
document.addEventListener('input',e=>{const input=e.target.closest?.('[data-wbf-model-input]');if(input)list(input.closest(finder))});
document.addEventListener('click',e=>{
 const button=e.target.closest?.('[data-wbf-model-value]');
 if(button){
  const root=button.closest(finder),s=native(root);
  if(s&&!button.disabled){
   s.value=button.dataset.wbfModelValue;
   s.dispatchEvent(new Event('change',{bubbles:true}));
   root.querySelector('[data-wbf-model-input]').value='';
   selected(root);
   hide(root);
  }
 }
 if(!e.target.closest?.(finder)){document.querySelectorAll(finder).forEach(hide)}
});
document.addEventListener('keydown',e=>{
 const input=e.target.closest?.('[data-wbf-model-input]');
 if(!input)return;
 const root=input.closest(finder);
 if(e.key==='Escape')hide(root);
 if(e.key==='Enter'){
  const first=root.querySelector('[data-wbf-model-value]:not(:disabled)');
  const box=root.querySelector('[data-wbf-model-results]');
  if(first&&box&&!box.hidden){e.preventDefault();first.click()}
 }
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});
else mount();
new MutationObserver(records=>{
 if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.(finder)||n.querySelector?.(finder)))))mount();
}).observe(document.documentElement,{subtree:true,childList:true});
})();